import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './VerticalNav.css';

const VerticalNav = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('hero');
  const [isVisible, setIsVisible] = useState(false);
  const navRef = useRef(null);
  
  // Define sections with their IDs and translation keys
  const sections = useMemo(() => [
    { id: 'hero', translationKey: 'navHero' },
    { id: 'whatweenable', translationKey: 'navWhatWeEnable' }, 
    { id: 'services', translationKey: 'navServices' },
    { id: 'results', translationKey: 'navResults' },
    { id: 'process', translationKey: 'navProcess' },
    { id: 'growth-partners', translationKey: 'navGrowthPartners' },
    { id: 'testimonials', translationKey: 'navTestimonials' },
    { id: 'pricing', translationKey: 'navPricing' },
    { id: 'contact', translationKey: 'navContact' }
  ], []);
  
  // Check if we've scrolled past the marquee
  useEffect(() => {
    const handleVisibility = () => {
      const marquee = document.querySelector('.marquee-section');
      if (marquee) {
        const marqueeBottom = marquee.offsetTop + marquee.offsetHeight;
        setIsVisible(window.scrollY > marqueeBottom);
      }
    };
    
    window.addEventListener('scroll', handleVisibility);
    handleVisibility(); // Initial check
    
    return () => {
      window.removeEventListener('scroll', handleVisibility);
    };
  }, []);
  
  // Track scroll position and update active section
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200; // Offset for better UX
      
      // Find the current section based on scroll position
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };
    
    // Add IDs to sections if they don't exist
    sections.forEach(section => {
      const sectionElement = document.querySelector(`.${section.id}-section`);
      if (sectionElement && !sectionElement.id) {
        sectionElement.id = section.id;
      }
    });
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [sections]);
  
  // Scroll to section when nav item is clicked
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 100, // Offset for header
        behavior: 'smooth'
      });
    }
  };
  
  return (
    <nav className={`vertical-nav ${isVisible ? 'visible' : ''}`} ref={navRef}>
      <div className="vertical-nav-track">
        {sections.map((section) => (
          <div 
            key={section.id}
            className={`vertical-nav-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => scrollToSection(section.id)}
          >
            <div className="vertical-nav-indicator"></div>
            <div className="vertical-nav-label">{t(section.translationKey)}</div>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default VerticalNav;
